module.exports = __webpack_public_path__ + "img/about-辅导项目-执业护士类.abb33296.jpg";